import React from 'react';

const WholeNumberFormatter = ({ value, keepDecimals = false }) => {
    if (value === null || value === undefined || value === "-") return "-";

    const numValue = Number(value);
    return <span>{keepDecimals ? numValue : Math.trunc(numValue)}</span>;
};

export default WholeNumberFormatter;